import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import List from "../../../../base/components/list.js";

import IcCheckSquare from "../../../../resources/svgs/ic_check_square.svg";

import { ProjectModel } from "../../../../models/projects/project_model.js";

const desktopBulletSide = 32;
const padBulletSide = 32;
const phoneBulletSide = 24;

const desktopBulletSpacing = 20;
const padBulletSpacing = 20;
const phoneBulletSpacing = 16;

const blockStyles = makeStyles(theme => ({
  root: {
  },
  list: {
    paddingLeft: `${desktopBulletSide + desktopBulletSpacing}px`,
    ['@media (max-width: 992px)']: {
      paddingLeft: `${padBulletSide + padBulletSpacing}px`,
    },
    ['@media (max-width: 768px)']: {
      paddingLeft: `${phoneBulletSide + phoneBulletSpacing}px`,
    },
    "& li": {
      marginBottom: "18px !important",
      paddingLeft: "0px !important",
      minHeight: `${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        marginBottom: "16px !important",
        minHeight: `${padBulletSide}px`,
      },
      ['@media (max-width: 768px)']: {
        marginBottom: "16px !important",
        minHeight: `${phoneBulletSide}px`,
      },
    },
    "& li:before": {
      backgroundImage: `url(${IcCheckSquare})`,
      top: "4px !important",
      left: `-${desktopBulletSide + desktopBulletSpacing}px !important`,
      backgroundSize: `${desktopBulletSide}px ${desktopBulletSide}px`,
      width: `${desktopBulletSide}px`,
      height: `${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        left: `-${padBulletSide + padBulletSpacing}px !important`,
        backgroundSize: `${padBulletSide}px ${padBulletSide}px`,
        width: `${padBulletSide}px`,
        height: `${padBulletSide}px`,
        
      },
      ['@media (max-width: 768px)']: {
        top: "2px !important",
        left: `-${phoneBulletSide + phoneBulletSpacing}px !important`,
        backgroundSize: `${phoneBulletSide}px ${phoneBulletSide}px`,
        height: `${phoneBulletSide}px`,
        width: `${phoneBulletSide}px`,
      },
    }
  }
}));

const KeyFactsBlock = (props) => {

  const classes = blockStyles();
  const { className, project: { highlights = [] } } = props;
  if(highlights.length === 0) {
    return <React.Fragment />
  }
  return (
    <div className = { clsx(classes.root, className) } >
      <h3 className = { classes.title } > { ProjectModel.fieldDisplayName("highlights") }</h3>
      <List className = { classes.list } >
        {
          highlights.map(highlight => (
            <li key = { highlight.id } >
              { highlight.text }
            </li>
          ))
        }
      </List>
    </div>
  );
}

export default KeyFactsBlock;